module.exports = __webpack_public_path__ + "static/img/03-al-shop.ca857d3d.jpg";